export var defaultProps = {
    zoom: 2,
    bigImgBoxCls: '',
};
